import { useState } from 'react'
import { useAdminAudit, useAdminCompanyCalls } from '@/entities/admin'
import { AdminAuditList } from '../shared/AdminAuditList'
import { AdminCallsTable } from '../shared/AdminCallsTable'
import { AdminPagination, AdminRemoteState } from '../shared/AdminRemoteState'
import { formatNumber } from '../shared/format'
import styles from '../AdminPages.module.css'

const LIMIT = 30

export function CompanyCallsTab({ companyId }: { companyId: number }) {
  const [kind, setKind] = useState('')
  const [status, setStatus] = useState('')
  const [offset, setOffset] = useState(0)
  const calls = useAdminCompanyCalls(companyId, {
    kind: kind || undefined,
    status: status || undefined,
    limit: LIMIT,
    offset,
  })

  return (
    <>
      <div className={styles.toolbar}>
        <label className={styles.field}>
          <span className={styles.label}>Тип звонка</span>
          <select
            className={styles.select}
            value={kind}
            onChange={(event) => {
              setKind(event.target.value)
              setOffset(0)
            }}
          >
            <option value="">Все типы</option>
            <option value="real">Телефонный</option>
            <option value="test">Тестовый</option>
          </select>
        </label>
        <label className={styles.field}>
          <span className={styles.label}>Состояние</span>
          <select
            className={styles.select}
            value={status}
            onChange={(event) => {
              setStatus(event.target.value)
              setOffset(0)
            }}
          >
            <option value="">Все состояния</option>
            <option value="pending">Ожидает</option>
            <option value="active">Идёт</option>
            <option value="completed">Завершён</option>
            <option value="failed">Ошибка</option>
          </select>
        </label>
        <span className={styles.count}>Найдено: {formatNumber(calls.data?.total ?? 0)}</span>
      </div>

      {calls.isPending ? (
        <AdminRemoteState kind="loading" />
      ) : calls.isError ? (
        <AdminRemoteState
          kind="error"
          message="Звонки компании не загрузились."
          onRetry={() => void calls.refetch()}
        />
      ) : !calls.data?.items.length ? (
        <AdminRemoteState
          kind="empty"
          title="У компании нет таких звонков"
          message="Измените фильтры или дождитесь первого звонка."
        />
      ) : (
        <>
          <AdminCallsTable
            items={calls.data.items}
            elevenLabsUsdPer1kCredits={calls.data.elevenLabsUsdPer1kCredits}
            showCompany={false}
          />
          <AdminPagination
            total={calls.data.total}
            offset={offset}
            limit={LIMIT}
            onChange={setOffset}
            disabled={calls.isFetching}
          />
        </>
      )}
    </>
  )
}

export function CompanyAuditTab({ companyId }: { companyId: number }) {
  const [offset, setOffset] = useState(0)
  const audit = useAdminAudit({ companyId, limit: LIMIT, offset })

  if (audit.isPending) return <AdminRemoteState kind="loading" />
  if (audit.isError) {
    return (
      <AdminRemoteState
        kind="error"
        message="Журнал компании не загрузился."
        onRetry={() => void audit.refetch()}
      />
    )
  }
  if (!audit.data?.items.length) {
    return (
      <AdminRemoteState
        kind="empty"
        title="В журнале компании пока нет записей"
        message="Изменения появятся здесь после первого административного действия."
      />
    )
  }

  return (
    <>
      <AdminAuditList items={audit.data.items} />
      <AdminPagination
        total={audit.data.total}
        offset={offset}
        limit={LIMIT}
        onChange={setOffset}
        disabled={audit.isFetching}
      />
    </>
  )
}
